import React from 'react';
import { fullImage, imgUrl } from '../../utils/images';
import { Trip } from '../../schema';
import { useGetProfilesQuery } from '../../store/backendApi';

export interface TripHeaderProps {
  tripData?: Trip;
}

export const EditTripHeader = (props: TripHeaderProps) => {
  const { data: profile } = useGetProfilesQuery();
  const tripData = props.tripData;

  if (!tripData) {
    return <div className="min-h-screen bg-canvas" />;
  }

  return (
    <div className="relative h-[65vh] w-full overflow-hidden">
      <img
        src={
          tripData?.headerFileName
            ? imgUrl(tripData.id, fullImage(tripData.headerFileName))
            : '/default-trip-header.jpg'
        }
        alt="Trip header"
        loading="eager"
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fetchpriority="high"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ objectPosition: 'center 30%' }}
      />
      <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-neutral-darkest to-transparent" />

      <div className="absolute bottom-0 left-0 w-full px-4 md:px-8 pb-12 pt-24 max-w-7xl mx-auto">
        <div>
          <h1
            className="text-4xl md:text-6xl lg:text-7xl font-bold text-on-dark tracking-tight mb-6 leading-tight"
            style={{
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
            }}
          >
            {tripData.title}
          </h1>

          <div className="flex flex-col md:flex-row md:items-end gap-6 md:gap-8">
            {/* Author */}
            <a
              href={`/profile/${tripData.ownerId}`}
              className="flex items-center gap-3 group transition-transform hover:scale-105 origin-left"
            >
              <div className="relative">
                <img
                  src={
                    `https://media.${process.env.REACT_APP_HOST}/users/${tripData.ownerId}` +
                    `-thumbnail.jpg?v=${Date.now()}`
                  }
                  className="w-14 h-14 rounded-full border-2 border-subtle object-cover shadow-md group-hover:border-surface"
                  alt="Author"
                  loading="eager"
                  onError={(e) => (e.currentTarget.src = '/default-profile-picture.jpg')}
                />
              </div>
              <div>
                <span className="block text-xs text-on-brand tracking-wider font-semibold">
                  {profile?.username ?? ''}
                </span>
                <span className="text-on-dark font-medium">View Profile</span>
              </div>
            </a>
            {/* Description */}
            {tripData.description && (
              <div className="text-lg md:text-xl text-on-brand font-light leading-relaxed max-w-2xl border-l-2 border-subtle pl-4 md:pl-6">
                {tripData.description}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
